



import React, { useEffect, useState, createContext, useContext } from "react";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyCCUbcwDlF2dUdt2T4uBU03QcgK1IP66Y0",
  authDomain: "delivit-new.firebaseapp.com",
  projectId: "delivit-new",
  storageBucket: "delivit-new.appspot.com",
  messagingSenderId: "704755381468",
  appId: "1:704755381468:web:9cd1930d9260f8e1ecf019",
  measurementId: "G-4641WV1740"
};

// Firebase Initialization
const firebaseApp = initializeApp(firebaseConfig);

// Custom hook to use Firebase messaging
const useFirebaseMessaging = () => {
  const [token, setToken] = useState(null);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          console.log(
            "Service Worker registered with scope:",
            registration.scope
          );

          const messaging = getMessaging(firebaseApp);

          // Request for FCM token
          getToken(messaging, {
            vapidKey:
              "BAl8zXb9A_OhLGhnRvDs3JWVc2b3aMZW5AY60vVY3QnKAO_5dYJuKJib2Yh-2XdJp7xr8eRmLHL2HEV-ZfMYCqo",
          })
            .then((currentToken) => {
              if (currentToken) {
                console.log("FCM Token:", currentToken);
                setToken(currentToken);
              } else {
                console.log(
                  "No registration token available. Request permission to generate one."
                );
              }
            })
            .catch((err) => {
              console.log("An error occurred while retrieving token: ", err);
            });

          // Listen for foreground messages
          onMessage(messaging, (payload) => {
            console.log("Message received in foreground: ", payload);
            setMessage(payload);
          });
        })
        .catch((err) => {
          console.log("Service Worker registration failed: ", err);
        });
    }
  }, []);

  return { token, message };
};

// Context to provide Firebase messaging data
export const FirebaseContext = createContext({ token: "", message: "" });

export const FirebaseProvider = ({ children }) => {
  const firebaseMessaging = useFirebaseMessaging();
  return (
    <FirebaseContext.Provider value={firebaseMessaging}>
      {children}
    </FirebaseContext.Provider>
  );
};

export const useFirebase = () => {
  return useContext(FirebaseContext);
};
